import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

import { Button } from '../../../../components/Button';

export const StyledSignalsContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 9px;
  width: 100%;
`;

export const StyledAllSignalsButton = styled(Button)`
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const StyledSignalItem = styled.div`
  padding: 12px;
  background-color: ${colorsPalettes.bluegrey[100]};
  border-radius: 6px;
  width: 100%;
`;

export const StyledSignalItemHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 8px;
  gap: 8px;
`;

export const StyledSignalItemHeaderText = styled.div`
  ${setFontVariant('caption', colorsPalettes.carbon[400])}
`;
export const StyledSignalItemHeaderTimeframe = styled.div`
  ${setFontVariant('caption', colorsPalettes.carbon[250])};
  margin-left: auto;
`;

export const StyledSignalTagsContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 4px;
  max-width: 100%;
  margin-top: 8px;
`;

export const StyledSignalTitleContainer = styled.div<{ tooltipMaxWidth?: string }>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  ${setFontVariant('body2', colorsPalettes.carbon[500])};
  max-width: 100%;
  gap: 4px;
  & > .text-overflow-tooltip {
    max-width: ${({ tooltipMaxWidth }) => tooltipMaxWidth ?? '95%'};
  }
`;

export const StyledTooltipContentWrapper = styled.div`
  max-height: 200px;
  overflow: auto;
`;
